import { createDebugAPI } from './debug.js';
/**
 * GameAPI 팩토리 함수
 *
 * @example
 * ```typescript
 * const api = createGameAPI(core, { exposeGlobal: true, debug: true });
 *
 * // 브라우저 콘솔에서:
 * GameAPI.state              // 현재 상태
 * GameAPI.dispatch({ type: 'CLICK' })  // 액션 실행
 * GameAPI.fastForward(60)    // 60초 시뮬레이션
 * GameAPI.debug.dumpState()  // 상태 JSON 출력
 * ```
 */
export function createGameAPI(core, options = {}) {
    const { exposeGlobal = false, globalName = 'GameAPI', debug = false } = options;
    const api = {
        get state() {
            return core.getState();
        },
        dispatch(action) {
            return core.dispatch(action);
        },
        fastForward(seconds, tickRate) {
            core.fastForward(seconds, tickRate);
        },
        reset(initialState) {
            core.reset(initialState);
        },
        on(event, callback) {
            return core.on(event, callback);
        },
        debug: debug ? createDebugAPI(core) : undefined
    };
    // 브라우저 환경에서 전역 노출
    if (exposeGlobal && typeof window !== 'undefined') {
        window[globalName] = api;
        if (debug) {
            console.log(`[GameAPI] Exposed as window.${globalName}`);
            console.log('[GameAPI] Available commands:');
            console.log(`  ${globalName}.state - Get current state`);
            console.log(`  ${globalName}.dispatch({ type: '...' }) - Dispatch action`);
            console.log(`  ${globalName}.fastForward(seconds) - Fast forward time`);
            console.log(`  ${globalName}.reset() - Reset game state`);
            if (api.debug) {
                console.log(`  ${globalName}.debug.dumpState() - Dump state as JSON`);
                console.log(`  ${globalName}.debug.getActions() - List registered actions`);
                console.log(`  ${globalName}.debug.getSystems() - List registered systems`);
            }
        }
    }
    return api;
}
/**
 * 전역 GameAPI 가져오기 (브라우저 환경)
 */
export function getGlobalAPI(globalName = 'GameAPI') {
    if (typeof window !== 'undefined') {
        return window[globalName];
    }
    return undefined;
}
//# sourceMappingURL=GameAPI.js.map